import React from 'react';
import { Nav } from '../../common/Nav.type';
import { env } from '../../di/lensinjector';

const LensWizStart = React.lazy(() => import('./start/LensWizStart'));
const LensWizStory = React.lazy(() => import('./poster/LensWizPoster'));
const LensWizVideoProp = React.lazy(() => import('./content/video/LensWizVideoProp'));
const LensWizTp = React.lazy(() => import('./tp/LensWizTp'));
const LensWizReady = React.lazy(() => import('./finish/LensWizFinish'));
const LensWizSocialProp = React.lazy(() => import('./content/social/LensWizSocialProp'));
const LensWizGiftProp = React.lazy(() => import('./content/gifts/LensWizGiftProp'));

export const lensWizRoutes = [
    {
        index: true,
        element: <LensWizStart env={env} />,
    },
    {
        element: <LensWizStart env={env} />,
        path: Nav.LENSWIZ_START,
    },
    {
        element: <LensWizStory env={env} />,
        path: Nav.LENSWIZ_POSTER,
    },
    {
        element: <LensWizStory env={env} />,
        path: Nav.LENSWIZ_CLONE,
    },
    {
        element: <LensWizVideoProp env={env} />,
        path: Nav.LENSWIZ_VIDEO,
    },
    {
        element: <LensWizSocialProp env={env} />,
        path: Nav.LENSWIZ_SOCIAL,
    },
    {
        element: <LensWizGiftProp env={env} />,
        path: Nav.LENSWIZ_GIFT,
    },
    {
        element: <LensWizTp env={env} />,
        path: Nav.LENSWIZ_TP,
    },
    {
        element: <LensWizReady env={env} />,
        path: Nav.LENSWIZ_READY,
    },
];
